"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const react_1 = require("react");
const context_1 = require("components/context");
const constants_1 = require("constants/constants");
const useClient = () => {
    const authContext = (0, react_1.useContext)(context_1.AuthContext);
    const [client, setClient] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const getClient = async () => {
            const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
            const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
            setClient(clientDataJSON);
        };
        getClient();
        authContext?.addClientChangeListener(async () => {
            const cupd = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
            //console.log("useClient authContext?.addClientChangeListener", cupd);
            const cl = JSON.parse(cupd ?? "{}");
            setClient(cl);
            /*console.log(
                "useClient authContext?.addClientChangeListener client",
                cl,
            );*/
        });
    }, []);
    return client;
};
exports.default = useClient;
